import React from 'react'
import { useNavigate } from 'react-router-dom'

const DashboardAnalytics = ({ dashboardData }) => {

    const navigate = useNavigate();



    return (
        <section className="col-lg-12 connectedSortable">
            <div className="row">
                <div className="col-md-3"
                 onClick={() => navigate("/vendor-admin/orders", { state: { tab: "totalOrders" } })}
                 style={{ cursor: "pointer" }}
                >
                    <div className="curveBox">
                        <div className="row row-flex">
                            <div className="col-3">
                                <div className="blackcolor iconSetting">
                                    <img src="/img/light-contacts.svg" alt="/" />
                                </div>
                            </div>
                            <div className="col-9 pl-2">
                                <h2 className="dashTitle font-weight-light my-2 ml-3">
                                    {dashboardData?.totalBookings || 0}
                                </h2>
                                <div className="dot-orange mb-3">
                                    <i className="fa fa-circle"></i> Total Orders
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-3"
                 onClick={() => navigate('/vendor-admin/orders', { state: { tab: "todayOrders" } })}
                 style={{ cursor: "pointer" }}
                >
                    <div className="curveBox">
                        <div className="row row-flex">
                            <div className="col-3">
                                <div className="blackcolor iconSetting">
                                    <img src="/img/light-contacts.svg" alt="/" />
                                </div>
                            </div>
                            <div className="col-9 pl-2">
                                <h2 className="dashTitle font-weight-light my-2 ml-3 text-black">
                                    {dashboardData?.todaysBookings || 0}

                                </h2>
                                <div className="dot-blue mb-3">
                                    <i className="fa fa-circle"></i> Today's Orders
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-3"
                 onClick={() => navigate('/vendor-admin/orders', { state: { tab: "completedOrders" } })}
                 style={{ cursor: "pointer" }}
                >
                    <div className="curveBox">
                        <div className="row row-flex">
                            <div className="col-3">
                                <div className="blackcolor iconSetting">
                                    <img src="/img/light-contacts.svg" alt="/" />
                                </div>
                            </div>
                            <div className="col-9 pl-2">
                                <h2 className="dashTitle font-weight-light my-2 ml-3">
                                    {dashboardData?.completedBookings || 0}

                                </h2>
                                <div className="dot-green mb-3">
                                    <i className="fa fa-circle"></i> Completed
                                    Bookings
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-3"
                 onClick={() => navigate('/vendor-admin/orders', { state: { tab: "cancelledOrders" } })}
                 style={{ cursor: "pointer" }}
                >
                    <div className="curveBox">
                        <div className="row row-flex">
                            <div className="col-3">
                                <div className="blackcolor iconSetting">
                                    <img src="/img/light-contacts.svg" alt="/" />
                                </div>
                            </div>
                            <div className="col-9 pl-2">
                                <h2 className="dashTitle font-weight-light my-2 ml-3">
                                    {dashboardData?.cancelledBookings || 0}
                                </h2>
                                <div className="dot-pink mb-3">
                                    <i className="fa fa-circle"></i> Cancelled
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-3"
                 onClick={() => navigate('/vendor-admin/customers')}
                 style={{ cursor: "pointer" }}
                >
                    <div className="curveBox">
                        <div className="row row-flex">
                            <div className="col-3">
                                <div className="blackcolor iconSetting">
                                    <img src="/img/light-contacts.svg" alt="/" />
                                </div>
                            </div>
                            <div className="col-9 pl-2">
                                <a
                                    className="dashTitle font-weight-light my-2 ml-3 text-black"
                                    href="#demandsanc"
                                    data-toggle="modal"
                                >
                                     {dashboardData?.totalCustomers || 0}
                                </a>
                                <div className="dot-pink mb-3">
                                    <i className="fa fa-circle"></i> Total Customers
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-3" 
                onClick={() => navigate('/vendor-admin/Staff')}
                style={{ cursor: "pointer" }}
                >
                    <div className="curveBox">
                        <div className="row row-flex">
                            <div className="col-3">
                                <div className="blackcolor iconSetting">
                                    <img src="/img/light-contacts.svg" alt="/" />
                                </div>
                            </div>
                            <div className="col-9 pl-2">
                                <h2 className="dashTitle font-weight-light my-2 ml-3">
                                    {dashboardData?.totalStaff || 0}
                                </h2>
                                <div className="dot-orange mb-3">
                                    <i className="fa fa-circle"></i> Total Staffs
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-3"
                    onClick={() => navigate('/vendor-admin/Branches')}
                    style={{ cursor: "pointer" }}
                >
                    <div className="curveBox">
                        <div className="row row-flex">
                            <div className="col-3">
                                <div className="blackcolor iconSetting">
                                    <img src="/img/light-contacts.svg" alt="/" />
                                </div>
                            </div>
                            <div className="col-9 pl-2">
                                <h2 className="dashTitle font-weight-light my-2 ml-3">
                                    {dashboardData?.totalBranch || 0}

                                </h2>
                                <div className="dot-blue mb-3">
                                    <i className="fa fa-circle"></i> Total Branch
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="curveBox">
                        <div className="row row-flex">
                            <div className="col-3">
                                <div className="blackcolor iconSetting">
                                    <img src="/img/light-contacts.svg" alt="/" />
                                </div>
                            </div>
                            <div className="col-9 pl-2">
                                <h2 className="dashTitle font-weight-light my-2 ml-3">
                                    {dashboardData?.totalRevenue || 0 }<span>$</span>
                                </h2>
                                <div className="dot-orange mb-3">
                                    <i className="fa fa-circle"></i> Total Revenue
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                 <div className="col-md-3">
                    <div className="curveBox">
                        <div className="row row-flex">
                            <div className="col-3">
                                <div className="blackcolor iconSetting">
                                    <img src="/img/light-contacts.svg" alt="/" />
                                </div>
                            </div>
                            <div className="col-9 pl-2">
                                <h2 className="dashTitle font-weight-light my-2 ml-3">
                                    {dashboardData?.totalPendingRevenue || 0}<span>$</span>
                                </h2>
                                <div className="dot-orange mb-3">
                                    <i className="fa fa-circle"></i> Total Pending Revenue
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default DashboardAnalytics